import ctt from '@/utils/const/deviceType';

export function getDeviceTrackPath({ deviceType }) {
  let name;

  switch (deviceType) {
    case ctt.GD_612:
    case ctt.GD_606:
      name = 'GD606Track';
      break;
  }

  return name;
}

export function getDeviceTrackReplayPath({ deviceType }) {
  let name;

  switch (deviceType) {
    case ctt.GD_612:
    case ctt.GD_606:
      name = 'GD606TrackReplay';
      break;
  }

  return name;
}

export const routeList = [
  {
    props: true,
    name: 'GD606Track',
    path: 'gd606/:sn/:deviceType',
    component: () => import('@/views/deviceTrack/gd606/index.vue'),
    meta: {
      key: true,
      noPadding: true,
      activeMenu: '/devices'
    }
  }
];

export const trackReplayRouteList = [
  {
    props: true,
    name: 'GD606TrackReplay',
    path: 'gd606',
    component: () => import('@/views/deviceTrack/gd606/replay.vue'),
    meta: {
      key: true,
      noPadding: true,
      activeMenu: '/query/track/list'
    }
  }
];
